module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_duo_cuad_3.5a8be3fb.png";